import { lightFormat } from 'date-fns';

export const updateObject = (oldObject, updatedValues) => {
    return {
        ...oldObject,
        ...updatedValues,
    };
};

export const getValidationValueByKey = (array, key) => {
    return array.find(x => x.key === key).value;
};

export const generateSixDigitRandomeNumber = () => {
    return Math.floor(100000 + Math.random() * 900000);
};

export const formatDate = date => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = `0${date.getDate()}`.slice(-2);
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const display = `${day} ${month} ${year}`;

    return display;
};

export const formatToDateTime = date => {
    // To comply with C# DateTime
    return lightFormat(new Date(date), 'yyyy-MM-dd');
};

export const formatToddMMyyyy = date => {
    // To comply with C# DateTime
    return lightFormat(new Date(date), 'dd-MM-yyyy');
};
